import {createRouter, createWebHistory} from 'vue-router';
import MainLandingPage from '@/views/MainLandingPage.vue';
import NetworkAdequacy from '@/views/networkAdequacy/NetworkAdequacy.vue';
import NetworkAdequacyForPBMs from '@/views/networkAdequacyForPBMs/NetworkAdequacyForPBMs.vue';
import AnnualRequiredFilingsAndForms from '@/views/annualRequiredFilingsAndForms/AnnualRequiredFilingsAndForms.vue';
import DocumentManagementTable from "@/views/documentManagement/DocumentManagementTable.vue";
import HealthInsuranceLicensingUpdates
  from '@/views/healthInsuranceLicensingUpdates/HealthInsuranceLicensingUpdates.vue';
import UploadsForQualityAssuranceExams
  from '@/views/uploadsForQualityAssuranceExams/UploadsForQualityAssuranceExams.vue';
import HMOTransactions from '@/views/hmoTransactions/HMOTransactions.vue';
import {useAuthStore} from '@/stores/authStore';
import Attestation from "@/views/networkAdequacyForPBMs/Attestation.vue";
import GeographicAccessMap from "@/views/networkAdequacyForPBMs/GeographicAccessMap.vue";
import NetworkWaiver from "@/views/networkAdequacyForPBMs/NetworkWaiver.vue";
import PBMRentalAgreement from "@/views/networkAdequacyForPBMs/PBMRentalAgreement.vue";
import ProviderFiles from "@/views/networkAdequacyForPBMs/ProviderFiles.vue";
import AnnualNetworkReview from "@/views/networkAdequacy/AnnualNetworkReview.vue";
import ProviderTerminations from "@/views/networkAdequacy/ProviderTerminations.vue";
import AdditionalProviderFiles from "@/views/networkAdequacy/ProviderFileUpdates.vue";
import {useDialogStore} from "@/stores/dialogStore.js";
import EntryPage from "@/views/EntryPage.vue";
import AppealsAndComplaints from "@/views/appealsAndComplaints/AppealsAndComplaints.vue";
import FileAnExternalAppeal from "@/views/appealsAndComplaints/FileAnExternalAppeal.vue";
import FileAConsumerComplaint from "@/views/appealsAndComplaints/FileAConsumerComplaint.vue";
import NetworksAwaitingReview from "@/views/admin/NetworksAwaitingReview.vue";
import AdminEntityView from "@/views/admin/AdminEntityView.vue";
import AdminUserView from "@/views/admin/AdminUserView.vue";
import AdminAuditLog from "@/views/admin/AdminAuditLog.vue";
import AdminReviewEntities from "@/views/admin/AdminReviewEntities.vue";
import ExternalAppealForm from "@/views/appealsAndComplaints/ExternalAppealForm.vue";
import ConsumerComplaintForm from "@/views/appealsAndComplaints/ConsumerComplaintForm.vue";
import UpdatesLicensingDocuments from "@/views/updatesLicensingDocuments/UpdatesLicensingDocuments.vue";
import AdminExternalAppeals from "@/views/admin/AdminExternalAppeals.vue";
import ViewSaveAsPdfExternalAppeal from "@/views/pdfGenFromHtmlPages/ViewSaveAsPdfExternalAppeal.vue";
import AdminConsumerComplaints from "@/views/admin/AdminConsumerComplaints.vue";
import CheckStatusAppealComplaint from "@/views/appealsAndComplaints/CheckStatusAppealComplaint.vue";
import AdminReviewNetworks from "@/views/admin/AdminReviewNetworks.vue";
import ViewSaveAsPdfConsumerComplaint from "@/views/pdfGenFromHtmlPages/ViewSaveAsPdfConsumerComplaint.vue";
import QualityAssurance from "@/views/qualityAssurance/QualityAssurance.vue";
import QualityAssuranceFileUploads from "@/views/qualityAssurance/QualityAssuranceFileUploads.vue";
import CreateExam from "@/views/qualityAssurance/CreateExam.vue";
import ReportingPhase from "@/views/qualityAssurance/ReportingPhase.vue";

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    next({ path: to.path });
  } else {
    next();
  }
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      return { top: 0, behavior: 'smooth' };
    } 
  },
  routes: [
    {
      path: '/',
      name: 'entrypage',
      meta: {
        title: 'Managed Care Systems Portal',
        requiresAuth: false,
      },
      component: EntryPage,
      beforeEnter: (to, from , next) => {
        const store = useAuthStore();
        if (store.authenticated) {
          next({ path: '/MainLandingPage' });
        } else {
          filterPath(to, from ,next);
        }
      }
    },
    {
      path: '/SignInRegister',
      name: 'signinregister',
      meta: {
        title: 'Sign In or Register',
      },
      component: () => import('@/components/registration/SignInRegister.vue'),
      beforeEnter: (to, from , next) => {
        const store = useAuthStore();
        if (store.authenticated) {
          next({ path: '/MainLandingPage' });
        } else {
          filterPath(to, from ,next);
        }
      }
    },
    {
      path: '/appealsAndComplaints',
      name: 'AppealsAndComplaints',
      meta: {
        title: 'Appeals and Complaints',
        requiresAuth: false,
        breadcrumb: [
          { label: 'Appeals and Complaints' }
        ],
      },
      component: AppealsAndComplaints
    },
    {
      path: '/appealsAndComplaints/FileAnExternalAppeal',
      name: 'FileAnExternalAppeal',
      meta: {
        title: 'File an External Appeal',
        requiresAuth: false,
        breadcrumb: [
          { label: 'Appeals and Complaints', route: '/AppealsAndComplaints' },
          { label: 'File An External Appeal' }
        ],
      },
      component: FileAnExternalAppeal
    },
    {
      path: '/appealsAndComplaints/ExternalAppealForm',
      name: 'ExternalAppealForm',
      meta: {
        title: 'External Appeal Form',
        requiresAuth: false,
        breadcrumb: [
          { label: 'Appeals and Complaints', route: '/appealsAndComplaints' },
          { label: 'File An External Appeal', route: '/appealsAndComplaints/FileAnExternalAppeal' },
          { label: 'External Appeal Form' }
        ],
      },
      component: ExternalAppealForm
    },
    {
      path: '/appealsAndComplaints/FileAConsumerComplaint',
      name: 'FileAConsumerComplaint',
      meta: {
        title: 'File A Consumer Complaint',
        requiresAuth: false,
        breadcrumb: [
          { label: 'Appeals and Complaints', route: '/appealsAndComplaints' },
          { label: 'File A Consumer Complaint' }
        ],
      },
      component: FileAConsumerComplaint
    },
    {
      path: '/appealsAndComplaints/ConsumerComplaintForm',
      name: 'ConsumerComplaintForm',
      meta: {
        title: 'Consumer Complaint Form',
        requiresAuth: false,
        breadcrumb: [
          { label: 'Appeals and Complaints', route: '/appealsAndComplaints' },
          { label: 'File A Consumer Complaint', route: '/appealsAndComplaints/FileAConsumerComplaint' },
          { label: 'Consumer Complaint Form' }
        ],
      },
      component: ConsumerComplaintForm
    },
    {
      path: '/appealsAndComplaints/CheckStatusAppealComplaint',
      name: 'CheckStatusAppealComplaint',
      meta: {
        title: 'Check Status of an Appeal or Consumer Complaint',
        requiresAuth: false,
        breadcrumb: [
          { label: 'Appeals and Complaints', route: '/appealsAndComplaints' },
          { label: 'Check Status of an Appeal or Consumer Complaint' }
        ],
      },
      component: CheckStatusAppealComplaint
    },
    {
      path: '/MainLandingPage',
      name: 'MainLandingPage',
      meta: {
        title: 'Main Landing Page',
        requiresAuth: true
      },
      beforeEnter: filterPath,
      component: MainLandingPage,
    },
    {
      path: '/ManageAccount',
      name: 'ManageAccount',
      meta: {
        title: 'Manage Account',
        requiresAuth: true
      },
      component: () => import('@/views/manageAccount/ManageAccountView.vue')
    },
    {
      path: '/Admin/NetworksAwaitingReview',
      name: 'Networks Awaiting Review',
      meta: {
        title: 'Networks Awaiting Review',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Networks Awaiting Review' }
        ],
      },
      component: NetworksAwaitingReview,
    },
    {
      path: '/Admin/AdminUser',
      name: 'Admin Users View',
      meta: {
        title: 'Admin Users View',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin Users View' }
        ],
      },
      component: AdminUserView,
    },
    {
      path: '/Admin/AdminEntity',
      name: 'Admin Entity View',
      meta: {
        title: 'Admin Entity View',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin Entity View' }
        ],
      },
      component: AdminEntityView,
    },
    {
      path: '/Admin/AdminAuditLog',
      name: 'Admin Audit Log',
      meta: {
        title: 'Admin Audit Log',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin Audit Log' }
        ],
      },
      component: AdminAuditLog,
    },
    {
      path: '/Admin/AdminReviewEntities',
      name: 'Admin Review Entities',
      meta: {
        title: 'Admin Review Entities',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin Review Entities' }
        ],
      },
      component: AdminReviewEntities,
    },
    {
      path: '/Admin/AdminReviewNetworks',
      name: 'Admin Review Networks',
      meta: {
          title: 'Admin Review Networks',
          requiresAuth: true,
          breadcrumb: [
              { label: 'Admin Review Networks' }
          ],
      },
      component: AdminReviewNetworks,
    },
    {
      path: '/Admin/AdminExternalAppeals',
      name: 'Admin External Appeals',
      meta: {
        title: 'Admin External Appeals',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin External Appeals' }
        ],
      },
      component: AdminExternalAppeals,
    },
    {
      path: '/pdfGenFromHtmlPages/ViewSaveAsPdfExternalAppeal',
      name: 'ViewSaveAsPdfExternalAppeal',
      meta: {
        title: 'View Save As PDF External Appeal',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin External Appeals' , route: '/Admin/AdminExternalAppeals'},
          { label: 'PDF View and Save Appeals'}
        ],
      },
      component: ViewSaveAsPdfExternalAppeal,
    },
    {
      path: '/Admin/AdminConsumerComplaints',
      name: 'Admin Consumer Complaints',
      meta: {
        title: 'Admin Consumer Complaints',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin Consumer Complaints' }
        ],
      },
      component: AdminConsumerComplaints,
    },
    {
      path: '/pdfGenFromHtmlPages/ViewSaveAsPdfConsumerComplaint',
      name: 'ViewSaveAsPdfConsumerComplaint',
      meta: {
        title: 'View Save As PDF Consumer Complaint',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Admin Consumer Complaints' , route: '/Admin/AdminConsumerComplaints'},
          { label: 'PDF View and Save Complaint'}
        ],
      },
      component: ViewSaveAsPdfConsumerComplaint,
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        title: 'Unauthorized'
      },
      beforeEnter: filterPath,
      component: () => import('../views/UnauthorizedView.vue')
    },    
    {
      path: '/:catchAll(.*)',
      name: 'notfound',
      component: () => import('../components/NotFound.vue'),
      meta: {
        title: 'Not Found',
      },
      beforeEnter: filterPath
    },
// Begin - Network Adequacy
    // TODO: Noah- after more functionality gets added to these pages it may make more sense to break out into a module.
    {
      path: '/NetworkAdequacy',
      name: 'NetworkAdequacy',
      meta: {
        title: 'Network Adequacy',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy' }
        ],
      },
      component: NetworkAdequacy,
    },
    {
      path: '/NetworkAdequacy/AnnualNetworkReview',
      name: 'AnnualNetworkReview',
      meta: {
        title: 'Annual Network Review for Upcoming Plan Year',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy', route: '/NetworkAdequacy' },
          { label: 'Annual Network Review for Upcoming Plan Year' }
        ],
      },
      component: AnnualNetworkReview,
    },
    {
      path: '/NetworkAdequacy/ProviderTerminations',
      name: 'ProviderTerminations',
      meta: {
        title: 'Provider Terminations',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy', route: '/NetworkAdequacy' },
          { label: 'Provider Terminations' }
        ],
      },
      component: ProviderTerminations,
    },
    {
      path: '/NetworkAdequacy/ProviderFileUpdates',
      name: 'ProviderFileUpdates',
      meta: {
        title: 'Provider File Updates',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy', route: '/NetworkAdequacy' },
          { label: 'Provider File Updates' }
        ],
      },
      component: AdditionalProviderFiles,
    },
// End - Network Adequacy
// Begin - Network Adequacy for PBMs
    // TODO: Noah- after more functionality gets added to these pages it may make more sense to break out into a module.
    {
      path: '/NetworkAdequacyForPBMs',
      name: 'NetworkAdequacyForPBMs',
      meta: {
        title: 'Network Adequacy For PBMs',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy For PBMs' }
        ],
      },
      component: NetworkAdequacyForPBMs,
    },
    {
      path: '/NetworkAdequacyForPBMs/Attestation',
      name: 'Attestation',
      meta: {
        title: 'Network Adequacy Attestation',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy For PBMs', route: '/NetworkAdequacyForPBMs' },
          { label: 'Attestation' }
        ],
      },
      component: Attestation,
    },
    {
      path: '/NetworkAdequacyForPBMs/GeographicAccessMap',
      name: 'Geographic Access Map',
      meta: {
        title: 'Geographic Access Map',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy For PBMs', route: '/NetworkAdequacyForPBMs' },
          { label: 'Geographic Access Map' }
        ],
      },
      component: GeographicAccessMap,
    },
    {
      path: '/NetworkAdequacyForPBMs/NetworkWaiver',
      name: 'Network Waiver',
      meta: {
        title: 'Network Waiver',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy For PBMs', route: '/NetworkAdequacyForPBMs' },
          { label: 'Network Waiver' }
        ],
      },
      component: NetworkWaiver,
    },
    {
      path: '/NetworkAdequacyForPBMs/PBMRentalAgreement',
      name: 'PBM Rental Agreement',
      meta: {
        title: 'PBM Rental Agreement',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy For PBMs', route: '/NetworkAdequacyForPBMs' },
          { label: 'PBM Rental Agreement' }
        ],
      },
      component: PBMRentalAgreement,
    },
    {
      path: '/NetworkAdequacyForPBMs/ProviderFiles',
      name: 'Provider Files',
      meta: {
        title: 'Provider Files',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Network Adequacy For PBMs', route: '/NetworkAdequacyForPBMs' },
          { label: 'Provider Files' }
        ],
      },
      component: ProviderFiles,
    },
// End - Network Adequacy for PBMs
    {
      path: '/AnnualRequiredFilingsAndForms',
      name: 'AnnualRequiredFilingsAndForms',
      meta: {
        title: 'Annual Required Filings And Forms',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Annual Required Filings And Forms' }
        ],
      },
      component: AnnualRequiredFilingsAndForms,
    },
    {
      path: '/DocumentManagementTable',
      name: 'DocumentManagementTable',
      meta: {
        title: 'Document Management Table',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Document Management Table' }
        ],
      },
      component: DocumentManagementTable,
    },
    {
      path: '/HealthInsuranceLicensingUpdates',
      name: 'HealthInsuranceLicensingUpdates',
      meta: {
        title: 'Health Insurance Licensing Updates',
        requiresAuth: true
      },
      component: HealthInsuranceLicensingUpdates,
    },
    {
      path: '/QualityAssurance',
      name: 'QualityAssurance',
      meta: {
        title: 'Quality Assurance',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Quality Assurance' }
        ],
      },
      component: QualityAssurance,
    },
    {
      path: '/qualityAssurance/CreateExam',
      name: 'CreateExam',
      meta: {
        title: 'Create an Exam',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Quality Assurance', route: '/QualityAssurance' },
          { label: 'Create an Exam' }
        ],
      },
      component: CreateExam,
    },
    {
      path: '/qualityAssurance/ReportingPhase',
      name: 'ReportingPhase',
      meta: {
        title: 'Reporting Phase',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Quality Assurance', route: '/QualityAssurance' },
          { label: 'Reporting Phase' }
        ],
      },
      component: ReportingPhase,
    },
    {
      path: '/qualityAssurance/QualityAssuranceFileUploads',
      name: 'QualityAssuranceFileUploads',
      meta: {
        title: 'Quality Assurance File Uploads',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Quality Assurance File Uploads' }
        ],
      },
      component: QualityAssuranceFileUploads,
    },
    {
      path: '/UploadsForQualityAssuranceExams',
      name: 'UploadsForQualityAssuranceExams',
      meta: {
        title: 'Uploads For Quality Assurance Exams',
        requiresAuth: true
      },
      component: UploadsForQualityAssuranceExams,
    },
    {
      path: '/HMOTransactions',
      name: 'HMOTransactions',
      meta: {
        title: 'HMO Transactions',
        requiresAuth: true
      },
      component: HMOTransactions,
    },
    {
      path: '/UpdatesLicensingDocuments',
      name: 'UpdatesLicensingDocuments',
      meta: {
        title: 'Licensing Updates & Other Required Reporting',
        requiresAuth: true,
        breadcrumb: [
          { label: 'Licensing Updates & Other Required Reporting' }
        ],
      },
      component: UpdatesLicensingDocuments,
    },
 ]
});

router.beforeEach(async (to, from, next) => {
  const dialogStore = useDialogStore();
  dialogStore.close();
  handleNavigation();

  function handleNavigation() {
    if (to.meta.requiresAuth) {
      const store = useAuthStore();
      if (!store.authenticated) {
        next({ path: '/' });
      } else if (to.meta.requiresAdmin && !store.user.isAdminUser) {
          next({ path: '/unauthorized' });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});

export default router;
